import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon, CheckCircle as ActivateIcon, Search as SearchIcon, Info as Info } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService'; // Ensure postData is defined
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import ReactDOM from 'react-dom';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CalculateIcon from '@mui/icons-material/Calculate';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // must assign to a variable
import PayRoll from './Geofoods.png';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import { InsertEmoticon } from '@material-ui/icons';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box } from '@mui/material';

function PayRollIndex() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, token, logout, userId } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const branchId = 0;
    const location = useLocation();
    const [isFocused, setIsFocused] = useState(false);

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    // Format date to dd-MM-yyyy
    const formatDateToDDMMYYYY = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleToDateChange = (e) => {
        const selected = e.target.value;
        setToDate(selected);

        const d = new Date(selected);
        const firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
        setFromDate(formatDateToDDMMYYYY(firstDay));
    };

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        const d = new Date();
        const firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
        setFromDate(formatDateToDDMMYYYY(firstDay));
        setData([]);
        setTableData([]);

        // setToDate(getFormattedCurrentDate());
        let lastDate = getFormattedLastDate();
        setToDate(getFormattedLastDate());
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const getFormattedLastDate = () => {
        const now = new Date(); // today
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // last day of this month

        const year = lastDay.getFullYear();
        const month = String(lastDay.getMonth() + 1).padStart(2, '0');
        const day = String(lastDay.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`; // format: yyyy-MM-dd (local time)
    };

    const [tableData, setTableData] = useState([]);
    const fetchtableData = async () => {

        setData([]);
        setTableData([]);
        try {
            const response = await fetchData('PayRollApi', `/PayRollDetails/${companyId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                setTableData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    const fetchtableGenarateData = async () => {
        setData([]);
        setTableData([]);
        try {
            const response = await fetchData('PayRollApi', `/GenaratePayRollDetails/${companyId}/${userId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                setTableData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredData = tableData.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const cellStyle = {
        padding: '4px 8px',
        border: '1px solid #ccc',
        fontSize: '11px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const exportToExcel = async () => {
        if (!data || data.length === 0) {
            alert("No data available to export.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Payroll');

        // Title row
        worksheet.mergeCells('A1', 'AE1');
        worksheet.getCell('A1').value = 'Payroll Report';
        worksheet.getCell('A1').alignment = { horizontal: 'center' };
        worksheet.getCell('A1').font = { bold: true, size: 16 };
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCE5FF' }  // light blue background
        };

        // Date row
        worksheet.addRow([`From Date: ${fromDate}`, `To Date: ${formatDate(toDate)}`]);

        worksheet.addRow([]); // Empty row

        // Column headers
        const headers = [
            'Sl.No', 'Employee ID', 'Employee Name', 'Working Days', 'Present Days', 'Half Days', 'LOP Days', 'Paid Days',
            'Gross', 'Basic Salary', 'HRA', 'DA', 'Travel Allowance', 'Other Allowance', 'Arrears', 'Gross Earnings',
            'Incentive', 'Bata (Day/Night/Peeling)', 'Extra Hours Bata', 'Water Tanker Bata', 'Net Earnings', 'EPF', 'ESI', 'LWF', 'Professional Tax', 'TDS', 'LOP Deductions', 'Advance',
            'Other Deductions', 'Total Deductions', 'Net Pay'
        ];
        const headerRow = worksheet.addRow(headers);

        // Style header row
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' } // light green
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Data rows
        data.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.EmployeeCode,
                item.EmployeeName,
                item.TotalWorkingDays,
                item.PresentDays,
                item.HalfDays,
                item.LOPDays,
                item.PaidDays,
                item.Gross,
                item.BasicSalary,
                item.HouseRentAllowance,
                item.DearnessAllowance,
                item.ConveyanceAllowance,
                item.OtherAllowance,
                item.Arrears,
                item.GrossEarnings,
                item.Incentive,
                item.PeelingBata,
                item.ExtraHoursBata,
                item.TankerBata,
                item.NetEarnings,
                item.EPF,
                item.ESI,
                item.LWF,
                item.ProfessionalTax,
                item.TDS,
                item.LOPDeductions,
                item.Advance,
                item.OtherDeductions,
                item.TotalDeductions,
                item.NetPay
            ]);
        });

        // Auto width for all columns
        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const val = cell.value ? cell.value.toString() : '';
                maxLength = Math.max(maxLength, val.length);
            });
            column.width = maxLength + 2;
        });

        // Export
        const buffer = await workbook.xlsx.writeBuffer();
        const filename = `Payroll_${fromDate.replace(/-/g, '')}_to_${formatDate(toDate).replace(/-/g, '')}.xlsx`;
        saveAs(new Blob([buffer]), filename);
    };

    // const generatePaySlipsPDF = (tableData) => {
    //     const formatCurrency = (amount) =>
    //         `₹ ${Number(amount ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

    //     const totalHighlightLabels = ['Gross Earnings', 'Total Deductions', 'Net Earnings', 'Net Pay'];
    //     const doc = new jsPDF();
    //     let monthYear = "";
    //     tableData.forEach((employee, index) => {

    //         if (index > 0) doc.addPage(); // start new page for every employee except first
    //         const payrollDate = new Date(employee.PayRollMonth);
    //         const month = payrollDate.toLocaleString('default', { month: 'long' });
    //         const year = payrollDate.getFullYear();
    //         monthYear = `${month} - ${year}`;
    //         const monthYearN = `${month}  ${year}`;

    //         doc.addImage(PayRoll, 'PNG', 160, 10, 25, 15); // width=25, height=15


    //         doc.setFontSize(16);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(String(employee.CompanyName || ''), 105, 20, { align: 'center' });

    //         doc.setFontSize(13);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(`Pay Slip - ${monthYearN || ''}`, 105, 30, { align: 'center' });

    //         doc.setDrawColor(0, 0, 0);


    //         autoTable(doc, {
    //             startY: 44,
    //             head: [['Employee Name', 'Designation']],
    //             body: [[employee.EmployeeName, employee.Designation]],
    //             styles: {
    //                 fontSize: 10,
    //                 lineWidth: 0.1,
    //                 lineColor: [0, 0, 0],
    //                 cellPadding: 2,
    //                 valign: 'middle',
    //                 textColor: 'black'
    //             },
    //             headStyles: {
    //                 fillColor: [0, 102, 204],
    //                 textColor: [255, 255, 255],
    //                 fontStyle: 'bold',
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 91 },
    //                 1: { cellWidth: 91 },
    //             },
    //         });

    //         autoTable(doc, {
    //             startY: doc.lastAutoTable.finalY + 5,
    //             body: [
    //                 ['Employee ID', employee.EmployeeCode, 'Gross Salary', (employee.GrossEarnings ?? 0).toFixed(2)],
    //                 ['UAN No', employee.UANNo, 'ESI No', employee.ESINo],
    //                 ['Pay Days', employee.TotalWorkingDays, 'Present Days', employee.PresentDays]
    //             ],
    //             styles: {
    //                 fontSize: 10,
    //                 lineWidth: 0.1,
    //                 lineColor: [0, 0, 0],
    //                 cellPadding: 2,
    //                 valign: 'middle',
    //                 textColor: 'black'
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 55 },
    //                 1: { cellWidth: 36, halign: 'right' },
    //                 2: { cellWidth: 55 },
    //                 3: { cellWidth: 36, halign: 'right' },
    //             },
    //         });

    //         autoTable(doc, {
    //             startY: doc.lastAutoTable.finalY + 5,
    //             head: [['Earnings', '', 'Deductions', '']],
    //             body: [
    //                 ['Basic Payable', (employee.BasicSalary ?? 0).toFixed(2), 'EPF', (employee.EPF ?? 0).toFixed(2)],
    //                 ['DA Payable', (employee.DearnessAllowance ?? 0).toFixed(2), 'ESI', (employee.ESI ?? 0).toFixed(2)],
    //                 ['HRA Payable', (employee.HouseRentAllowance ?? 0).toFixed(2), 'TDS', (employee.TDS ?? 0).toFixed(2)],
    //                 ['Conveyance', (employee.ConveyanceAllowance ?? 0).toFixed(2), 'Advance', (employee.Advance ?? 0).toFixed(2)],
    //                 ['Other Allowances', (employee.OtherAllowance ?? 0).toFixed(2), 'LWF', (employee.LWF ?? 0).toFixed(2)],
    //                 ['Arrears', (employee.Arrears ?? 0).toFixed(2), 'Professional Tax', (employee.ProfessionalTax ?? 0).toFixed(2)],
    //                 ['Gross Earnings', (employee.GrossEarnings ?? 0).toFixed(2), 'Other Deductions', (employee.OtherDeductions ?? 0).toFixed(2)],

    //                 ...(employee.PeelingBata > 0
    //                     ? [['Bata (Day/Night/Peeling)', (employee.PeelingBata ?? 0).toFixed(2), '', '']]
    //                     : []),


    //                 ...(employee.PeelingBata > 0
    //                     ? [['Extra Hours Bata', (employee.ExtraHoursBata ?? 0).toFixed(2), '', '']]
    //                     : []),


    //                 ...(employee.PeelingBata > 0
    //                     ? [['Water Tanker Bata', (employee.TankerBata ?? 0).toFixed(2), '', '']]
    //                     : []),


    //                 ['Incentive', (employee.Incentive ?? 0).toFixed(2), 'Total Deductions', (employee.TotalDeductions ?? 0).toFixed(2)],
    //                 ['Net Earnings', (employee.NetEarnings ?? 0).toFixed(2), 'Net Pay', (employee.NetPay ?? 0).toFixed(2)],
    //             ],
    //             styles: {
    //                 fontSize: 10,
    //                 lineWidth: 0.1,
    //                 lineColor: [0, 0, 0],
    //                 cellPadding: 2,
    //                 valign: 'middle',
    //                 textColor: 'black'
    //             },
    //             headStyles: {
    //                 fillColor: [0, 102, 204],
    //                 textColor: [255, 255, 255],
    //                 fontStyle: 'bold',
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 55, color: 'black' },  
    //                 1: { cellWidth: 36, color: 'black', halign: 'right' },
    //                 2: { cellWidth: 55, color: 'black' },
    //                 3: { cellWidth: 36, color: 'black', halign: 'right' },
    //             },

    //             didParseCell: function (data) {
    //                 const rowIndex = data.row.index;
    //                 const colIndex = data.column.index;


    //                 const boldCells = [
    //                     { row: 6, col: 0 }, { row: 6, col: 1 }, 
    //                     { row: 7, col: 2 }, { row: 7, col: 3 },
    //                     { row: 8, col: 0 }, { row: 8, col: 1 }, 
    //                     { row: 8, col: 2 }, { row: 8, col: 3 }, 
    //                 ];

    //                 const shouldBold = boldCells.some(cell => cell.row === rowIndex && cell.col === colIndex);

    //                 if (shouldBold) {
    //                     data.cell.styles.fontStyle = 'bold';
    //                     data.cell.styles.fillColor = [230, 230, 230]; 
    //                 }
    //             }



    //         });



    //     });
    //     doc.save(`All_PaySlips_${monthYear}.pdf`);
    // };

    const generatePaySlipsPDF = (tableData) => {
        const formatCurrency = (amount) =>
            `₹ ${Number(amount ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

        const doc = new jsPDF();
        let monthYear = "";

        tableData.forEach((employee, index) => {
            if (index > 0) doc.addPage(); // new page per employee

            const payrollDate = new Date(employee.PayRollMonth);
            const month = payrollDate.toLocaleString('default', { month: 'long' });
            const year = payrollDate.getFullYear();
            monthYear = `${month} - ${year}`;
            const monthYearN = `${month}  ${year}`;

            // Company logo
            doc.addImage(PayRoll, 'PNG', 160, 10, 25, 15);

            // Header: Company name & Pay Slip title
            doc.setFontSize(16);
            doc.setFont('helvetica', 'bold');
            doc.text(String(employee.CompanyName || ''), 105, 20, { align: 'center' });

            doc.setFontSize(13);
            doc.text(`Pay Slip - ${monthYearN || ''}`, 105, 30, { align: 'center' });

            // --- Employee Info Table ---
            autoTable(doc, {
                startY: 44,
                head: [['Employee Name', 'Designation']],
                body: [[employee.EmployeeName, employee.Designation]],
                styles: {
                    fontSize: 10,
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                    cellPadding: 2,
                    valign: 'middle',
                    textColor: 'black',
                },
                headStyles: {
                    fillColor: [0, 102, 204],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                },
                columnStyles: {
                    0: { cellWidth: 91 },
                    1: { cellWidth: 91 },
                },
            });

            // --- Employee Details Table ---
            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 5,
                body: [
                    ['Employee ID', employee.EmployeeCode, 'Gross Salary', (employee.GrossEarnings ?? 0).toFixed(2)],
                    ['UAN No', employee.UANNo, 'ESI No', employee.ESINo],
                    ['Pay Days', employee.TotalWorkingDays, 'Present Days', employee.PresentDays],
                ],
                styles: {
                    fontSize: 10,
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                    cellPadding: 2,
                    valign: 'middle',
                    textColor: 'black',
                },
                columnStyles: {
                    0: { cellWidth: 55 },
                    1: { cellWidth: 36, halign: 'right' },
                    2: { cellWidth: 55 },
                    3: { cellWidth: 36, halign: 'right' },
                },
            });

            // ✅ Conditional Bata rows
            const bataRows = [
                ...(employee.PeelingBata > 0
                    ? [['Bata (Day/Night/Peeling)', (employee.PeelingBata ?? 0).toFixed(2), '', '']]
                    : []),
                ...(employee.PeelingBata > 0
                    ? [['Extra Hours Bata', (employee.ExtraHoursBata ?? 0).toFixed(2), '', '']]
                    : []),
                ...(employee.PeelingBata > 0
                    ? [['Water Tanker Bata', (employee.TankerBata ?? 0).toFixed(2), '', '']]
                    : []),
            ];

            // ✅ Main Earnings & Deductions Table
            const bodyData = [
                ['Basic Payable', (employee.BasicSalary ?? 0).toFixed(2), 'EPF', (employee.EPF ?? 0).toFixed(2)],
                ['DA Payable', (employee.DearnessAllowance ?? 0).toFixed(2), 'ESI', (employee.ESI ?? 0).toFixed(2)],
                ['HRA Payable', (employee.HouseRentAllowance ?? 0).toFixed(2), 'TDS', (employee.TDS ?? 0).toFixed(2)],
                ['Conveyance', (employee.ConveyanceAllowance ?? 0).toFixed(2), 'Advance', (employee.Advance ?? 0).toFixed(2)],
                ['Other Allowances', (employee.OtherAllowance ?? 0).toFixed(2), 'LWF', (employee.LWF ?? 0).toFixed(2)],
                ['Arrears', (employee.Arrears ?? 0).toFixed(2), 'Professional Tax', (employee.ProfessionalTax ?? 0).toFixed(2)],
                ['Gross Earnings', (employee.GrossEarnings ?? 0).toFixed(2), 'Other Deductions', (employee.OtherDeductions ?? 0).toFixed(2)],
                ...bataRows,
                ['Incentive', (employee.Incentive ?? 0).toFixed(2), 'Total Deductions', (employee.TotalDeductions ?? 0).toFixed(2)],
                ['Net Earnings', (employee.NetEarnings ?? 0).toFixed(2), 'Net Pay', (employee.NetPay ?? 0).toFixed(2)],
            ];

            // Dynamically calculate which rows to bold
            const grossRowIndex = 6;
            const totalDeductionRowIndex = 7 + bataRows.length;
            const netRowIndex = 8 + bataRows.length;

            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 5,
                head: [['Earnings', '', 'Deductions', '']],
                body: bodyData,
                styles: {
                    fontSize: 10,
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                    cellPadding: 2,
                    valign: 'middle',
                    textColor: 'black',
                },
                headStyles: {
                    fillColor: [0, 102, 204],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                },
                columnStyles: {
                    0: { cellWidth: 55 },
                    1: { cellWidth: 36, halign: 'right' },
                    2: { cellWidth: 55 },
                    3: { cellWidth: 36, halign: 'right' },
                },

                didParseCell: function (data) {
                    const row = data.row.index;
                    const col = data.column.index;

                    const boldCells = [
                        { row: grossRowIndex, col: 0 }, { row: grossRowIndex, col: 1 },
                        { row: totalDeductionRowIndex, col: 2 }, { row: totalDeductionRowIndex, col: 3 },
                        { row: netRowIndex, col: 0 }, { row: netRowIndex, col: 1 },
                        { row: netRowIndex, col: 2 }, { row: netRowIndex, col: 3 },
                    ];

                    const isBold = boldCells.some(cell => cell.row === row && cell.col === col);
                    if (isBold) {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.fillColor = [230, 230, 230]; // light gray background
                    }
                },
            });

            // ✅ Optional Footer
            const finalY = doc.lastAutoTable.finalY + 10;
            doc.setFontSize(10);
            doc.text('For ' + (employee.CompanyName || ''), 20, finalY);
            doc.text('Authorized Signature', 150, finalY + 15);
            doc.line(145, finalY + 12, 190, finalY + 12); // signature line
            doc.setFontSize(8);
            
        });

        // Save all payslips together
        doc.save(`All_PaySlips_${monthYear.replace(/\s+/g, '_')}.pdf`);
    };


    const [editRowIndex, setEditRowIndex] = useState(null);
    const [editedRowData, setEditedRowData] = useState({});

    const handleEditClick = (index) => {
        setEditRowIndex(index);
        setEditedRowData({ ...tableData[index] });
    };

    const handleInputChange = (e, field) => {
        const updatedRow = {
            ...editedRowData,
            [field]: e.target.value
        };
        const recalculatedFields = recalculatePayrollFields(updatedRow);
        setEditedRowData({ ...updatedRow, ...recalculatedFields });
    };

    const recalculatePayrollFields = (row) => {
        const {
            BasicSalary = 0,
            WageRate = 0,
            HouseRentAllowance = 0,
            DearnessAllowance = 0,
            ConveyanceAllowance = 0,
            OtherAllowance = 0,
            Arrears = 0,
            Incentive = 0,
            LOPDays = 0,
            EPF = 0,
            ESI = 0,
            LWF = 0,
            ProfessionalTax = 0,
            TDS = 0,
            Advance = 0,
            OtherDeductions = 0,
            LOPDeductions = 0,
        } = row;

        const gross = BasicSalary + HouseRentAllowance + DearnessAllowance + ConveyanceAllowance + OtherAllowance + Arrears + Incentive;
        const NetEarnings = parseFloat(gross).toFixed(2);
        const TotalDeductions = (parseFloat(EPF) + parseFloat(ESI) + parseFloat(LWF) + parseFloat(ProfessionalTax) + parseFloat(TDS) + parseFloat(Advance) + parseFloat(OtherDeductions) + parseFloat(LOPDeductions)).toFixed(2);
        const NetPay = parseFloat(NetEarnings - TotalDeductions).toFixed(2);
        let UpdatedBy = userId;
        return { NetEarnings, TotalDeductions, NetPay, UpdatedBy };
    };

    const handleUpdateClick = async () => {
        const row = editedRowData;
        try {
            const response = await updateData('PayRollApi', row.Id, row, token);
            setEditRowIndex(null);
            setEditedRowData({});
            toast.success('Payroll updated successfully');

            fetchtableData(); // Refresh the table data after update

        } catch (error) {
            console.error('Update failed:', error);
            toast.error('Update failed');
        }
    };

    const handleCancelClick = () => {
        setEditRowIndex(null);
        setEditedRowData({});
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '-10px' }}>

            <div
                className="flex items-center font-serif gap-3 p-2 rounded-xl shadow-sm"
                style={{ background: "#f9fafb", marginBottom: "10px" }}
            >
                <h6
                    className="uppercase tracking-wide font-serif text-black mt-2 text-gray-700 flex-grow"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                >
                    Payroll Management
                </h6>

                {/* Search */}
                <input
                    type="text"
                    placeholder="🔍 Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? "240px" : "180px",
                        height: "30px",
                        border: "1px solid #ddd",
                        borderRadius: "20px",
                        padding: "0 14px",
                        fontSize: "12px",
                        transition: "all 0.3s ease",
                        outline: "none",
                    }}
                />

                {/* From Date */}
                <input
                    type="text"
                    id="fromDate"
                    value={fromDate}
                    disabled
                    placeholder="dd-MM-yyyy"
                    style={{
                        height: "30px",
                        fontSize: "12px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "0 6px",
                        fontFamily: 'Arial, sans-serif',
                    }}
                />

                {/* To Date */}
                <input
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    style={{
                        height: "30px",
                        fontSize: "12px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "0 6px",
                        fontFamily: 'Arial, sans-serif',
                    }}
                />

                <div className="flex items-center gap-1">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={fetchtableGenarateData}
                        sx={{
                            borderRadius: '12px',
                            minWidth: '40px',
                            height: '24px',
                            fontSize: '9px',
                            padding: '0 5px'
                        }}
                    >
                        <Tooltip title="Generate Payroll" arrow>
                            <span className="uppercase flex items-center gap-1 text-[10px]">
                                <CalculateIcon style={{ fontSize: "17px" }} />  Generate Pay Roll
                            </span>
                        </Tooltip>
                    </Button>

                    <Button
                        variant="outlined"
                        size="small"
                        onClick={fetchtableData}
                        sx={{
                            borderRadius: '12px',
                            minWidth: '40px',
                            height: '24px',
                            fontSize: '9px',
                            padding: '0 5px'
                        }}
                    >
                        <Tooltip title="Refresh Data" arrow>
                            <span className="uppercase flex items-center gap-1 text-[10px]">
                                <RefreshIcon style={{ fontSize: "17px" }} /> Refresh
                            </span>
                        </Tooltip>
                    </Button>

                    <Button
                        variant="outlined"
                        size="small"
                        onClick={exportToExcel}
                        sx={{
                            borderRadius: '12px',
                            minWidth: '45px',
                            height: '24px',
                            fontSize: '9px',
                            padding: '0 5px'
                        }}
                    >
                        <Tooltip title="Download Excel" arrow>
                            <span className="uppercase flex items-center gap-1 text-[10px]">
                                <FileDownloadIcon style={{ fontSize: "17px" }} /> Excel
                            </span>
                        </Tooltip>
                    </Button>

                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => generatePaySlipsPDF(tableData)}
                        sx={{
                            borderRadius: '12px',
                            minWidth: '45px',
                            height: '24px',
                            fontSize: '9px',
                            padding: '0 5px'
                        }}
                    >
                        <Tooltip title="View Salary Slip" arrow>
                            <span className="uppercase flex items-center gap-1 text-[10px]">
                                <ReceiptLongIcon style={{ fontSize: "17px" }} /> Salary Slip
                            </span>
                        </Tooltip>
                    </Button>
                </div>
            </div>

            <div className="w-full mb-4 rounded-xl border border-gray-200 shadow-md overflow-hidden">
                <TableContainer
                    component={Paper}
                    sx={{
                        maxHeight: 580,
                        overflowY: 'auto',
                        border: '1px solid #e0e0e0',
                    }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow> {/* 'Wage Rate', */}
                                {[
                                    'Sl.No', 'Employee ID', 'Employee Name', 'Working Days', 'Present Days', 'Half Days', 'LOP Days', 'Paid Days',
                                    'Gross', 'Basic', 'HRA', 'DA', 'Travel Allowance', 'Other Allowance', 'Arrears', 'Gross Earnings',
                                    'Incentive', 'BATA (DAY/NIGHT/PEELING)', 'EXTRA HOURS BATA', 'WATER TANKER BATA', 'Net Earnings', 'EPF', 'ESI', 'LWF', 'Prof. Tax', 'TDS', 'LOP Deduction', 'Advance',
                                    'Other Deduction', 'Total Deductions', 'Net Pay'
                                ].map((title, idx) => (
                                    <TableCell
                                        key={idx}
                                        sx={{
                                            background: 'linear-gradient(to right, #103641, #144350)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: '10px',
                                            border: '1px solid #ccc',
                                            textAlign: 'center',
                                            position: 'sticky',
                                            top: 0,
                                            left:
                                                idx === 0 ? 0 :
                                                    idx === 1 ? 30 :
                                                        idx === 2 ? 70 : undefined,
                                            zIndex: idx <= 2 ? 11 : 10,
                                            whiteSpace: 'nowrap',
                                            textTransform: 'uppercase',
                                            padding: '0px 2px',
                                        }}
                                    >
                                        {title}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {/* {tableData.map((row, index) => ( */}
                            {filteredData.map((row, index) => (
                                <TableRow
                                    key={row.id}
                                    sx={{
                                        backgroundColor: editRowIndex === index ? '#fff3cd' : '#f7f9f7', // Light yellow for edit mode
                                        '&:hover': { backgroundColor: '#e1f5fe' },
                                        transition: 'background-color 0.3s ease'
                                    }}
                                >
                                    {/* Sticky Columns */}
                                    <TableCell sx={{ ...cellStyle, position: 'sticky', left: 0, backgroundColor: editRowIndex === index ? '#fff3cd' : '#f7f9f7', zIndex: 1 }}>{index + 1}</TableCell>
                                    <TableCell sx={{ ...cellStyle, position: 'sticky', left: 30, backgroundColor: editRowIndex === index ? '#fff3cd' : '#f7f9f7', zIndex: 1 }}>{row.EmployeeCode}</TableCell>
                                    <TableCell sx={{ ...cellStyle, position: 'sticky', left: 70, backgroundColor: editRowIndex === index ? '#fff3cd' : '#f7f9f7', zIndex: 1, textAlign: 'left' }}>{row.EmployeeName}</TableCell>

                                    {/* Attendance & Wage Info */}
                                    <TableCell sx={cellStyle}>{row.TotalWorkingDays}</TableCell>
                                    <TableCell sx={cellStyle}>{row.PresentDays}</TableCell>
                                    <TableCell sx={cellStyle}>{row.HalfDays}</TableCell>
                                    <TableCell sx={cellStyle}>{row.LOPDays}</TableCell>
                                    <TableCell sx={cellStyle}>{row.PaidDays}</TableCell>
                                    {/* <TableCell sx={{ ...cellStyle, fontWeight: 'bold', textAlign: 'right' }}>{row.WageRate}</TableCell> */}

                                    {/* Earnings (Read-only) */}
                                    {[row.Gross, row.BasicSalary, row.HouseRentAllowance, row.DearnessAllowance, row.ConveyanceAllowance, row.OtherAllowance, row.Arrears]
                                        .map((val, i) => (
                                            <TableCell key={i} sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : '#D9E9CF', fontWeight: 'bold', textAlign: 'right' }}>
                                                {val}
                                            </TableCell>
                                        ))}
                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : '#F6F1DE', fontWeight: 'bold', textAlign: 'right' }}>
                                        {row.GrossEarnings}
                                    </TableCell>

                                    {/* Incentive */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : 'white',
                                            fontWeight: 'bold',
                                            textAlign: 'right',
                                            color: 'brown'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.Incentive || ''}
                                                onChange={(e) => handleInputChange(e, 'Incentive')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.Incentive
                                        )}
                                    </TableCell>

                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : 'white', fontWeight: 'bold', textAlign: 'right', color: 'brown' }}>
                                        {row.PeelingBata}
                                    </TableCell>

                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : 'white', fontWeight: 'bold', textAlign: 'right', color: 'brown' }}>
                                        {row.ExtraHoursBata}
                                    </TableCell>

                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : 'white', fontWeight: 'bold', textAlign: 'right', color: 'brown' }}>
                                        {row.TankerBata}
                                    </TableCell>

                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : 'whitesmoke', fontWeight: 'bold', textAlign: 'right', color: 'darkblue' }}>
                                        {row.NetEarnings}
                                    </TableCell>

                                    {/* EPF */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.EPF || ''}
                                                onChange={(e) => handleInputChange(e, 'EPF')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.EPF
                                        )}
                                    </TableCell>

                                    {/* ESI */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.ESI || ''}
                                                onChange={(e) => handleInputChange(e, 'ESI')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.ESI
                                        )}
                                    </TableCell>
                                    {/* LWF */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.LWF || ''}
                                                onChange={(e) => handleInputChange(e, 'LWF')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.LWF
                                        )}
                                    </TableCell>
                                    {/* Professional Tax */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.ProfessionalTax || ''}
                                                onChange={(e) => handleInputChange(e, 'ProfessionalTax')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.ProfessionalTax
                                        )}
                                    </TableCell>
                                    {/* TDS */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.TDS || ''}
                                                onChange={(e) => handleInputChange(e, 'TDS')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.TDS
                                        )}
                                    </TableCell>
                                    {/* LOP Deductions */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.LOPDeductions || ''}
                                                onChange={(e) => handleInputChange(e, 'LOPDeductions')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.LOPDeductions
                                        )}
                                    </TableCell>

                                    {/* Advance */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.Advance || ''}
                                                onChange={(e) => handleInputChange(e, 'Advance')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.Advance
                                        )}
                                    </TableCell>

                                    {/* OtherDeductions */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...cellStyle,
                                            backgroundColor: editRowIndex === index ? '#fff3cd' : '#C4E1E6',
                                            fontWeight: 'bold',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {editRowIndex === index ? (
                                            <TextField
                                                variant="standard"
                                                value={editedRowData.OtherDeductions || ''}
                                                onChange={(e) => handleInputChange(e, 'OtherDeductions')}
                                                InputProps={{
                                                    disableUnderline: false,
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            row.OtherDeductions
                                        )}
                                    </TableCell>
                                    {/* Total Deductions and Net Pay (Read-only) */}
                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : '#f5c6cb', fontWeight: 'bold', textAlign: 'right' }}>
                                        {editRowIndex === index ? (
                                            editedRowData.TotalDeductions
                                        ) : (
                                            row.TotalDeductions
                                        )}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, backgroundColor: editRowIndex === index ? '#fff3cd' : '#c4e7a8ff', fontWeight: 'bold', textAlign: 'right', color: '#000000' }}>
                                        {editRowIndex === index ? (
                                            editedRowData.NetPay
                                        ) : (
                                            row.NetPay
                                        )}
                                    </TableCell>
                                    {/* Actions */}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default PayRollIndex;